import services from '../services';
import { AsyncActionStatus, ThunkAction } from './common.actionTypes';
import {
  FetchAiFilterValuesAction,
  FETCH_AI_FILTER_VALUES,
} from './aiFilterValues.actionTypes';

export function fetchAiFilterValues(): ThunkAction<FetchAiFilterValuesAction> {
  return async (dispatch, getState) => {
    // Skip if already loaded or a fetch is in flight, so concurrent callers don't
    // fire duplicate requests. ERROR falls through so a failed fetch can retry.
    const { status } = getState().aiFilterValues;
    if (status === AsyncActionStatus.READY || status === AsyncActionStatus.LOADING) {
      return;
    }

    dispatch({ type: FETCH_AI_FILTER_VALUES.START });

    return services.text.fetchAiFilterValues()
      .then(result => dispatch({ type: FETCH_AI_FILTER_VALUES.SUCCESS, result }))
      .catch(error => dispatch({ type: FETCH_AI_FILTER_VALUES.ERROR, error }));
  };
}
